import { render } from "./BasicElementsPage.vue?vue&type=template&id=87232dd8&ts=true"
import script from "./BasicElementsPage.vue?vue&type=script&lang=ts"
export * from "./BasicElementsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__